import {
  Card,
  CardBody,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  Flex,
  Box,
  Text,
  Divider,
  useDisclosure,
  IconButton,
  Input,
} from '@chakra-ui/react';
import { ViewIcon } from '@chakra-ui/icons';
import TableContainer from 'components/common/TableContainer';
import { useEffect, useMemo, useState } from 'react';
import { MdBusiness, MdPerson, MdAssuredWorkload } from 'react-icons/md';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import {
  ChangedBy,
  ChangedFields,
  EmployeeId,
  EmployeeName, 
} from './ProfileAuditCol';
import CompanyAudit from './CompanyAudit';
import httpInjectorService from 'services/http-injector.service';
import { BulletList } from 'react-content-loader';
import { Empty } from 'antd';
import { SimpleGrid } from '@chakra-ui/react';
import PayrollAudit from './PayrollAudit';
import { MdFilterListAlt, MdDownload } from 'react-icons/md';
import * as XLSX from 'xlsx'
import { demoProfileAuditLogs } from 'components/demodata/Dummydata';

const ProfileAudit = () => {
  const [profileauditlogs, setProfileAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedLog, setSelectedLog] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Sl No',
        accessor: 'serial',
        disableFilters: true,
        disableSortBy: false,
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: 'Employee ID',
        accessor: 'employee_id',
        disableFilters: true,
        Cell: (cellProps) => <EmployeeId {...cellProps} />,
      },
      {
        Header: 'Employee Name',
        accessor: 'username',
        disableFilters: true,
        Cell: (cellProps) => <EmployeeName {...cellProps} />,
      },
      {
        Header: 'Changed Fields',
        accessor: 'changed_fields',
        disableFilters: true,
        Cell: (cellProps) => <ChangedFields {...cellProps} />,
      },
      {
        Header: 'Changed By',
        accessor: 'changed_by_name',
        disableFilters: true,
        Cell: (cellProps) => <ChangedBy {...cellProps} />,
      },
      {
        Header: 'Action',
        accessor: 'action',
        disableFilters: true,
        Cell: ({ row }) => (
          <Flex justifyContent="center" align="center" gap={3}>
            <IconButton
              icon={<ViewIcon />}
              size="sm"
              variant="ghost"
              colorScheme="purple"
              aria-label="View Details"
              onClick={() => {
                setSelectedLog(row.original);
                onOpen();
              }}
            />
          </Flex>
        ),
      },
    ],
    [],
  );

  const formatDate = (date) => {
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}-${String(
      d.getMonth() + 1,
    ).padStart(2, '0')}-${d.getFullYear()}`;
  };

  const getProfileAuditLogs = async (sDate, eDate) => {
    setLoading(true);
    const start = sDate || startDate;
    const end = eDate || endDate;
    if (!start || !end) return;
    try {
      const isDemoMode = localStorage.getItem('demoMode') === 'true';
      
      if (isDemoMode) {
        setProfileAuditLogs(demoProfileAuditLogs);
        return;
      }
      const response = await httpInjectorService.getProfileAuditLogs({
        startDate: start,
        endDate: end,
      });
      if (response.status === 'success') {
        setProfileAuditLogs(response.data);
      } else {
        setProfileAuditLogs([]);
      }
    } catch {
      setProfileAuditLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const getCurrentWeekRange = () => {
    // const today = new Date();
    // const dayOfWeek = today.getDay();
    // const monday = new Date(today);
    // monday.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
    // const sunday = new Date(monday);
    // sunday.setDate(monday.getDate() + 6);
    const today = new Date();
    const end = new Date(today);
    const start = new Date(today);
    start.setDate(today.getDate() - 6);
    return {
      // start: monday.toISOString().split('T')[0],
      // end: sunday.toISOString().split('T')[0],
      start: start.toISOString().split('T')[0],
      end: end.toISOString().split('T')[0],
    };
  };

  useEffect(() => {
    const { start, end } = getCurrentWeekRange();
    setStartDate(start);
    setEndDate(end);
    getProfileAuditLogs(start, end);
  }, []);

  useEffect(() => {
    if (activeTab === '1') {
      const { start, end } = getCurrentWeekRange();
      setStartDate(start);
      setEndDate(end);
      getProfileAuditLogs(start, end);
    }
  }, [activeTab]);

  const renderValue = (value, field) => {
    if (!value) return 'null';

    // If DOB field → format date
    if (field === 'dob') {
      const date = new Date(value);
      if (!isNaN(date)) {
        return date.toISOString().split('T')[0];
      }
    }

    if (typeof value === 'string') return value;

    if (typeof value === 'object') return JSON.stringify(value);

    return String(value);
  };

 const exportToExcel = () => {
  if (profileauditlogs.length === 0) return; 
  const ws = XLSX.utils.json_to_sheet(profileauditlogs); 
  const wb = XLSX.utils.book_new(); 
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); 
  XLSX.writeFile(wb, "profile_audit.xlsx"); 
};

  return (
    <div 
    data-tour="profile-audit-module"
    style={{ marginTop: '80px' }}>
      <Card>
        <CardBody>
          <Nav tabs>
            <NavItem>
              <NavLink data-tour="profile-audit-myprofile-tab"
                className={classnames({ active: activeTab === '1' })}
                onClick={() => toggleTab('1')}
                style={{display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'purple'}}
              >
                <MdPerson style={{ marginRight: '5px' }} />
                <span className="d-none d-sm-inline">My Profile</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink data-tour="profile-audit-payroll-tab"
                className={classnames({ active: activeTab === '2' })}
                onClick={() => toggleTab('2')}
                style={{display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'purple' }}
              >
                <MdAssuredWorkload style={{ marginRight: '5px' }} />
                <span className="d-none d-sm-inline">Payroll</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink data-tour="profile-audit-company-tab"
                className={classnames({ active: activeTab === '3' })}
                onClick={() => toggleTab('3')}
                style={{display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'purple' }}
              >
                <MdBusiness style={{ marginRight: '5px' }} />
                <span className="d-none d-sm-inline">Company Profile</span>
              </NavLink>
            </NavItem>
          </Nav>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <div>
                  <Flex data-tour="profile-audit-filters" gap={4} align="end" flexWrap="wrap">
                    <Box>
                      <Text fontSize="sm" marginTop={3} mb={1}>
                        Start Date<span className="text-danger">*</span>
                      </Text>
                      <Input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </Box>

                    <Box>
                      <Text fontSize="sm" marginTop={3} mb={1}>
                        End Date<span className="text-danger">*</span>
                      </Text>
                      <Input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </Box>

                    <Button
                      rounded={2}
                      mb="1"
                      size="sm"
                      leftIcon={<MdFilterListAlt/>}
                      colorScheme="purple"
                      onClick={() => getProfileAuditLogs()}
                    >
                      Filter
                    </Button>
                  </Flex>
                  {loading ? (
                    <div>
                      <BulletList />
                    </div>
                  ) : (
                    <div>
                      {profileauditlogs.length === 0 ? (
                        <Empty className="mt-4" />
                      ) : (
                        <div>
                          <Button data-tour="profile-audit-download-btn"
                            leftIcon={<MdDownload />}
                            colorScheme="purple"
                            size="sm"
                            rounded={2}
                            float="right"
                            onClick={exportToExcel}
                          >
                            Download
                          </Button>
                          <div className="table-container mt-4">
                            <TableContainer
                              columns={columns}
                              data={profileauditlogs}
                              isGlobalFilter={true}
                              customPageSize={10}
                              className="custom-header-css"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                </div>
              </TabPane>
              <TabPane tabId="2">
                <PayrollAudit isActive={activeTab === '2'} />
              </TabPane>
              <TabPane tabId="3">
                <CompanyAudit isActive={activeTab === '3'} className="mt-4" />
              </TabPane>
            </TabContent>
        </CardBody>
      </Card>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="xl">
          <ModalHeader bg="purple.600" color="white">
            Profile Audit Details
          </ModalHeader>
          <ModalCloseButton color="white" />

          <ModalBody p={6} maxH="70vh" overflowY="auto">
            {selectedLog && (
              <>
                {/* Header Section */}
                <Box
                  mb={6}
                  p={4}
                  bg="purple.50"
                  borderRadius="lg"
                  border="1px solid"
                  borderColor="purple.100"
                >
                  <Text fontWeight="bold" fontSize="xl" color="purple.700">
                    {selectedLog.username} ({selectedLog.employee_id})
                  </Text>

                  <Text fontSize="sm" color="gray.600" mt={1}>
                    Changed By: <b>{selectedLog.changed_by_name}</b>
                  </Text>

                  <Text fontSize="sm" color="gray.500">
                    {new Date(selectedLog.changed_at).toLocaleString('en-IN', {
                      dateStyle: 'medium',
                      timeStyle: 'short',
                    })}
                  </Text>
                </Box>

                <Divider mb={6} />

                {/* Changed Fields Grid */}
                <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={6}>
                  {selectedLog.changed_fields.map((field, index) => (
                    <Box
                      key={index}
                      p={5}
                      borderRadius="xl"
                      bg="white"
                      border="1px solid"
                      borderColor="gray.200"
                      boxShadow="md"
                      transition="0.2s"
                      _hover={{
                        boxShadow: 'lg',
                        transform: 'translateY(-2px)',
                      }}
                    >
                      {/* Field Name */}
                      <Text
                        fontWeight="semibold"
                        fontSize="sm"
                        color="purple.600"
                        mb={4}
                        textTransform="capitalize"
                      >
                        {field.replace(/_/g, ' ')}
                      </Text>

                      {/* Old & New Section */}
                      <Flex gap={4} direction={{ base: 'column', md: 'row' }}>
                        {/* Old Value */}
                        <Box
                          flex={1}
                          bg="red.50"
                          p={3}
                          borderRadius="md"
                          border="1px solid"
                          borderColor="red.100"
                        >
                          <Text fontSize="xs" color="red.500" mb={1}>
                            OLD
                          </Text>
                          <Text fontWeight="medium" fontSize="sm">
                            {renderValue(selectedLog.old_data?.[field], field)}
                          </Text>
                        </Box>

                        {/* New Value */}
                        <Box
                          flex={1}
                          bg="green.50"
                          p={3}
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="xs" color="green.500" mb={1}>
                            NEW
                          </Text>
                          <Text fontWeight="medium" fontSize="sm">
                            {renderValue(selectedLog.new_data?.[field], field)}
                          </Text>
                        </Box>
                      </Flex>
                    </Box>
                  ))}
                </SimpleGrid>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="purple" rounded="2" onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ProfileAudit;
